module.exports = __webpack_public_path__ + "static/media/climbing1.c091192b.svg";